export const getNestedError = (
  errors: any,
  path: string
): string | undefined => {
  if (errors[path]) {
    return errors[path]
  }

  const parts = path.split(".")
  let current = errors
  for (const part of parts) {
    if (current && typeof current === "object" && part in current) {
      current = current[part]
    } else {
      return undefined
    }
  }
  return typeof current === "string" ? current : undefined
}
